enum DataTest {
	'discovery-status-confirm-btn' = 'discovery-status-confirm-btn',
}

export default DataTest;
